import { FormControl, Grid, Modal, TextField } from '@mui/material';
import TopBar from '../Layout/TopBar';
import MyButton from '../Layout/MyButton';
import { PLANIFICATION_STATUS, PROFIL } from '../../constants/enum';
import { faCheck, faExclamationCircle, faPlus, faTimes, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import FormLabel from '@mui/material/FormLabel';
import MyComboBox from '../Layout/MyComboBox';
import { DateTimePicker } from '@mui/x-date-pickers';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';

const AvailablePeriodModal = (props) => {
    const {
        css,
        demandePassageStyle,
        loading,
        availablePeriod,
        profil,
        openModal,
        planification,
        resetComponent,
        handleDisabledStep,
        handleTronconChange,
        removeTroncon,
        handleValidAvailablePeriod,
        handleCloseModal,
        statusList,
        listAvailableRequestPass,
        listeRaisonsSociales,
        centerStatusList,
        goToDate,
        setAvailablePeriod,
        setOpenContractModal,
        createdFromRequestPass,
        setOpenModalIndisponibility,
        isDeleted
    } = props;

    const [minDate, setMinDate] = useState(null);
    const [unavailableCenters, setUnavailableCenters] = useState([]);
    const [oneCenterUnvailable, setOneCenterUnvailable] = useState(false);
    const [isDisabledSaveBtn, setIsDisabledSaveBtn] = useState(false);
    let allCentersAccepted = availablePeriod.centers.filter((aCenter) => aCenter.status === 'VALIDATED').length === availablePeriod.centers.length;

    let canConfirm = availablePeriod.start ? moment(availablePeriod.start).subtract('15', 'days').isBefore(moment()) : false;

    useEffect(() => {
        if (availablePeriod.start) {
            setMinDate(availablePeriod.start);
        }

        if (unavailableCenters.length > 0) {
            let type = availablePeriod.concernedPath.selectedPath;
            if (availablePeriod.concernedPath[type]) {
                let centers = [];
                availablePeriod.concernedPath[type].map((aTroncon) => {
                    if (aTroncon.centres && aTroncon.centres.length !== 0) {
                        aTroncon.centres.map((aCenter) => {
                            if (!centers.includes(aCenter)) {
                                centers.push(aCenter);
                            }
                        });
                    }
                });

                let includedSome = centers.some((aCenter) => {
                    if (unavailableCenters.includes(aCenter)) {
                        setOneCenterUnvailable(true);
                        return true;
                    }
                });

                if (!includedSome) {
                    setOneCenterUnvailable(false);
                }
            }
        }
    }, [availablePeriod]);

    useEffect(() => {
        if (availablePeriod.start && availablePeriod.end && availablePeriod.client && availablePeriod.requestPass) {

            if(availablePeriod.start === 'Invalid date' || availablePeriod.end === 'Invalid date') {
                return;
            }

            axios({
                method: 'post',
                url: URL_API + '/planification/check-unavailable-period',
                data: {
                    centers: availablePeriod.centers.map((aCenter) => aCenter.id),
                    startDate: moment(availablePeriod.start).format().split('+')[0],
                    endDate: moment(availablePeriod.end).format().split('+')[0],
                },
            })
            .then((response) => {
                if (response.data.length > 0) {
                    let unavailableCenters = response.data;

                    unavailableCenters.map((aUnavailableCenter) => {
                        availablePeriod.centers.map((aCenter) => {
                            if (Number(aCenter.id) === aUnavailableCenter) {
                                setUnavailableCenters([...unavailableCenters, Number(aCenter.id)]);
                                setAvailablePeriod({
                                    ...availablePeriod,
                                    centers: availablePeriod.centers.map((aCenter) => {
                                        if (Number(aCenter.id) === aUnavailableCenter) {
                                            aCenter.unavailable = true;
                                        }
                                        return aCenter;
                                    }),
                                });
                            }
                        });
                    });
                } else {
                    setUnavailableCenters([]);
                    setAvailablePeriod({
                        ...availablePeriod,
                        centers: availablePeriod.centers.map((aCenter) => {
                            aCenter.unavailable = false;
                            return aCenter;
                        }),
                    });
                }
            });
        }
    }, [availablePeriod.start, availablePeriod.end, availablePeriod.client, availablePeriod.requestPass]);


    // Gère la possibilité de sauvegarder en fonction du nombre de demande de passage
    useEffect(() => {
        if (availablePeriod.askType === 'optional' && availablePeriod.nbOptionalPlanification <= 2) {
            setIsDisabledSaveBtn(false);
        } else if (availablePeriod.askType === 'wanted') {
            let remaining = availablePeriod.concernedPath.selectedPath === 'aller' ? availablePeriod.remainingAller : availablePeriod.remainingRetour;
            if (availablePeriod.initialPath !== null && availablePeriod.initialPath !== availablePeriod.concernedPath.selectedPath) {
                remaining -= 1;
            }

            if (availablePeriod.id !== 0 ? remaining >= 0 : remaining > 0) {
                setIsDisabledSaveBtn(false);
            } else {
                setIsDisabledSaveBtn(true);
            }
        }

    }, [availablePeriod.numDemand, availablePeriod.maxPlanification, availablePeriod.askType, availablePeriod.concernedPath.selectedPath, availablePeriod.remainingAller, availablePeriod.remainingRetour, availablePeriod.nbOptionalPlanification]);

    useEffect(() => {
        const trajet = 'aller'
        // TODO: si availablePeriod.concernedPath.full === 'true' récupèrer tous les tronçons du trajet sélectionné
        if (String(availablePeriod.concernedPath.full) === "true") {
            setAvailablePeriod((prev) => ({
                ...prev,
                concernedPath: {
                    ...prev.concernedPath,
                    aller: prev.aller,
                },
            }));
        }
    }, [availablePeriod.concernedPath.full])

    return (
        <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
            <div className='modal'>
                <div style={css.modalAvailablePeriod}>
                    <TopBar
                        title={`Période de passage ${availablePeriod.requestPass ? `[N°${availablePeriod.requestPass ?? ''}-${availablePeriod.numDemand ?? ''}/${availablePeriod.maxPlanification ?? ''}]` : ''}`}
                        className='topbar-contenu'
                        color='#bb0060c4'
                        titleWidth={'100%'}
                        buttons={
                            <div className='topbar-buttons'>
                                {profil.profil === 1 || profil.profil === 2 ?
                                    <>
                                        {planification &&
                                            <MyButton
                                                label={'Planning'}
                                                style={'mediumDefaultButton'}
                                                onClick={() => {
                                                    resetComponent();
                                                    goToDate(planification.metadata.startDate);
                                                }}
                                                sx={{backgroundColor: '#7f2352c2 !important'}}
                                            />
                                        }
                                        {availablePeriod.status === PLANIFICATION_STATUS.CONFIRMED_CENTERS &&
                                            <MyButton
                                                label={'Génération de l\'accord de passage'}
                                                style={'mediumDefaultButton'}
                                                sx={{ width: '350px', backgroundColor: '#7f2352c2 !important'}}
                                                onClick={() => setOpenContractModal(true)}
                                            />
                                        }
                                    </> : null
                                }
                                <MyButton
                                    onClick={() => handleCloseModal()}
                                    label='Fermer'
                                    icon={faXmark}
                                    style={'mediumDefaultButton'}
                                    sx={{backgroundColor: '#7f2352c2 !important'}}
                                />
                            </div>
                        }
                    />

                    <div style={css.containerAvailablePeriod}>
                        {
                            loading &&
                            <div className='row' style={css.fullRow}>
                                <ClipLoader
                                    color='#0094ca'
                                    loading={loading}
                                    size={75}
                                    css={'display: flex; margin: 25px;justify-content: center;'}
                                />
                            </div>
                        }
                        {
                            !loading && <>
                                <div>
                                    {
                                        <>
                                            <FormControl style={{ width: '15%' }}>
                                                <FormLabel>Sélectionner un client</FormLabel>
                                                <MyComboBox disabled={handleDisabledStep([0, 1]) || createdFromRequestPass}
                                                            label={'Client'}
                                                            options={listeRaisonsSociales}
                                                            value={availablePeriod.client}
                                                            id={'selectedType'}
                                                            setter={(e) => setAvailablePeriod({
                                                                ...availablePeriod,
                                                                client: e,
                                                            })}
                                                            style={{ width: 'auto', margin: '0' }}
                                                />
                                            </FormControl>
                                        </>
                                    }
                                    <FormControl style={{ width: '17%' }}>
                                        <FormLabel>Sélectionner un dossier (*)</FormLabel>
                                        <MyComboBox disabled={handleDisabledStep([0, 1]) || createdFromRequestPass}
                                                    label={'Dossier N°'}
                                                    options={listAvailableRequestPass}
                                                    value={availablePeriod.requestPass ? String(availablePeriod.requestPass) : ''}
                                                    id={'selectedDossier'}
                                                    setter={(e) => setAvailablePeriod({
                                                        ...availablePeriod,
                                                        requestPass: e,
                                                    })}
                                                    style={{ width: 'auto', margin: '0' }}
                                        />
                                    </FormControl>
                                    <FormControl style={{ width: '18%' }}>
                                        <FormLabel>Choisissez une date de début</FormLabel>
                                        <DateTimePicker
                                            disabled={handleDisabledStep([1, 2, 3])}
                                            label='Date début'
                                            name='startDate'
                                            value={availablePeriod.start}
                                            style={{ ...demandePassageStyle.textField, width: 'auto', margin: '0' }}
                                            onChange={(newValue) => {
                                                setAvailablePeriod({ ...availablePeriod, start: newValue });
                                                setMinDate(newValue);
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                            inputVariant='outlined'
                                        />
                                    </FormControl>
                                    <FormControl style={{ width: '18%' }}>
                                        <FormLabel>Choisissez une date de fin</FormLabel>
                                        <DateTimePicker
                                            disabled={handleDisabledStep([1, 2, 3])}
                                            label='Date fin'
                                            minDate={moment(minDate).toDate()}
                                            name='endDate'
                                            value={availablePeriod.end}
                                            style={{ ...demandePassageStyle.textField, width: 'auto', margin: '0' }}
                                            onChange={(newValue) => setAvailablePeriod({
                                                ...availablePeriod,
                                                end: newValue,
                                            })}
                                            renderInput={(params) => <TextField {...params} />}
                                            inputVariant='outlined'
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <FormLabel>Type de demande</FormLabel>
                                        <RadioGroup
                                            name='typeDemande'
                                            value={availablePeriod.askType}
                                            style={{ display: 'flex', marginLeft: '20px' }}
                                            onChange={(e) => setAvailablePeriod({
                                                ...availablePeriod,
                                                askType: e.target.value,
                                            })}
                                        >
                                            <FormControlLabel
                                                disabled={handleDisabledStep([1, 2, 3]) || availablePeriod.nbWantedPlanification >= availablePeriod.maxPlanification}
                                                value={'wanted'}
                                                control={<Radio />}
                                                label='Souhaitée'
                                                labelPlacement={'start'} />
                                            <FormControlLabel
                                                disabled={availablePeriod.nbOptionalPlanification >= 2 || handleDisabledStep([1, 2, 3])}
                                                value={'optional'}
                                                control={<Radio />}
                                                label='Optionnelle'
                                                labelPlacement={'start'} />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <Grid container spacing={3} style={{ padding: '0 40px' }}>
                                    <Grid item xs={3}>
                                        <Grid item container direction={'column'} spacing={3}>
                                            <Grid item sx={{
                                                '&:hover': {
                                                    '> fieldset:first-of-type': {
                                                        borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                                    },
                                                },
                                            }}>
                                                <fieldset
                                                    style={{
                                                        ...css.gridFieldSet,
                                                        maxHeight: '250px',
                                                        minHeight: '250px',
                                                    }}>
                                                    <legend style={css.gridLegend}>Trajet concerné</legend>
                                                    {!availablePeriod.hasReturn &&
                                                        <p style={{fontSize: 9}}>Pas de trajet retour pour ce dossier</p>
                                                    }
                                                    <div style={css.gridItem}>
                                                        <label>Trajet :</label>
                                                        <div>
                                                            <RadioGroup name='concernedPath'
                                                                        value={availablePeriod.concernedPath.selectedPath}
                                                                        style={css.gridRadioGroup}
                                                                        onChange={(e) => setAvailablePeriod({
                                                                            ...availablePeriod,
                                                                            concernedPath: {
                                                                                ...availablePeriod.concernedPath,
                                                                                selectedPath: e.target.value,
                                                                            },
                                                                        })}
                                                            >
                                                                <FormControlLabel
                                                                    disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3], null)}
                                                                    value={'aller'}
                                                                    control={<Radio />}
                                                                    label='Aller'
                                                                    labelPlacement={'start'}
                                                                />
                                                                {availablePeriod.hasReturn &&
                                                                    <FormControlLabel
                                                                        disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3], null)}
                                                                        value={'retour'}
                                                                        control={<Radio />}
                                                                        label='Retour'
                                                                        labelPlacement={'start'}
                                                                    />
                                                                }
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                    <div style={css.gridItem}>
                                                        <label>Trajet complet :</label>
                                                        <div>
                                                            <RadioGroup name='trajetComplet'
                                                                        value={availablePeriod.concernedPath.full}
                                                                        style={css.gridRadioGroup}
                                                                        disabled={
                                                                            profil.profil === PROFIL.CLIENT
                                                                                ? (availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()))
                                                                                    ? false
                                                                                    : handleDisabledStep([1, 2, 3])
                                                                                : handleDisabledStep([1, 2, 3])
                                                                        }
                                                                        onChange={(e) => setAvailablePeriod({
                                                                            ...availablePeriod,
                                                                            concernedPath: {
                                                                                ...availablePeriod.concernedPath,
                                                                                full: e.target.value === "true",
                                                                                aller: [],
                                                                                retour: [],
                                                                            },
                                                                        })}
                                                            >
                                                                <FormControlLabel
                                                                    disabled={
                                                                        profil.profil === PROFIL.CLIENT
                                                                            ? (availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()))
                                                                                ? false
                                                                                : handleDisabledStep([1, 2, 3])
                                                                            : handleDisabledStep([1, 2, 3])
                                                                    }
                                                                    value={true}
                                                                    control={<Radio />}
                                                                    label='Oui'
                                                                    labelPlacement={'start'} />
                                                                <FormControlLabel
                                                                    disabled={
                                                                        profil.profil === PROFIL.CLIENT
                                                                            ? (availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()))
                                                                                ? false
                                                                                : handleDisabledStep([1, 2, 3])
                                                                            : handleDisabledStep([1, 2, 3])
                                                                    }
                                                                    value={false}
                                                                    control={<Radio />}
                                                                    label='Non'
                                                                    labelPlacement={'start'} />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                    <div style={css.gridItem}>
                                                        <label>Suite à un report :</label>
                                                        <div>
                                                            <RadioGroup name='report'
                                                                        value={availablePeriod.concernedPath.fromReport}
                                                                        style={css.gridRadioGroup}
                                                                        onChange={(e) => setAvailablePeriod({
                                                                            ...availablePeriod,
                                                                            concernedPath: {
                                                                                ...availablePeriod.concernedPath,
                                                                                fromReport: e.target.value,
                                                                            },
                                                                        })}
                                                            >
                                                                <FormControlLabel
                                                                    disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3])}
                                                                    value={true}
                                                                    control={<Radio />}
                                                                    label='Oui'
                                                                    labelPlacement={'start'} />
                                                                <FormControlLabel
                                                                    disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3])}
                                                                    value={false}
                                                                    control={<Radio />}
                                                                    label='Non'
                                                                    labelPlacement={'start'} />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div>
                                                        <label>Tronçons</label>
                                                        <div>
                                                            {availablePeriod.concernedPath.selectedPath === 'aller'  && availablePeriod.aller && availablePeriod.aller.map((aTroncon, index) => {
                                                                if (aTroncon.nomSection === null) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <div key={index}
                                                                         style={{
                                                                             ...css.gridItem,
                                                                             justifyContent: 'flex-start',
                                                                             gap: '10px',
                                                                         }}>
                                                                        <p>{aTroncon.numeroSection} {aTroncon.nomSection ? aTroncon.nomSection : 'Inconnu'} :</p>
                                                                        <RadioGroup name={`troncon-aller-${index}`}
                                                                                    onChange={(e) => handleTronconChange(e, index, 'aller')}
                                                                                    onClick={(e) => removeTroncon(aTroncon.numeroSection, 'aller')}
                                                                        >
                                                                            <FormControlLabel
                                                                                disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3], null)}
                                                                                value={true}
                                                                                control={<Radio />}
                                                                                label={''}
                                                                                checked={
                                                                                    availablePeriod.concernedPath.full === 'true' ? true : availablePeriod.concernedPath.selectedPath === 'aller' ? availablePeriod.concernedPath.aller && availablePeriod.concernedPath.aller.filter((aTronconSelected) => aTronconSelected.numeroSection === aTroncon.numeroSection).length > 0 : false
                                                                                }
                                                                            />
                                                                        </RadioGroup>
                                                                    </div>
                                                                );
                                                            })}
                                                            {availablePeriod.concernedPath.selectedPath === 'retour' && availablePeriod.trajetType === '1' && availablePeriod.retour && availablePeriod.retour.map((aTroncon, index) => {
                                                                if (aTroncon.nomSection === null) {
                                                                    return null;
                                                                }
                                                                return (
                                                                    <div key={index}
                                                                         style={{
                                                                             ...css.gridItem,
                                                                             justifyContent: 'flex-start',
                                                                             gap: '10px',
                                                                         }}>
                                                                        <p>{aTroncon.numeroSection} {aTroncon.nomSection ? aTroncon.nomSection : 'Inconnu'} :</p>
                                                                        <RadioGroup name={`troncon-retour-${index}`}
                                                                                    onChange={(e) => handleTronconChange(e, index, 'retour')}
                                                                                    onClick={(e) => removeTroncon(aTroncon.numeroSection, 'retour')}
                                                                        >
                                                                            <FormControlLabel
                                                                                disabled={profil.profil === PROFIL.CLIENT && availablePeriod.start && moment(availablePeriod.start).subtract('1', 'weeks').isAfter(moment()) ? false : handleDisabledStep([1, 2, 3], null)}
                                                                                value={true}
                                                                                control={<Radio />}
                                                                                label={''}
                                                                                checked={
                                                                                    availablePeriod.concernedPath.full === 'true' ? true : availablePeriod.concernedPath.selectedPath === 'retour' ? availablePeriod.concernedPath.retour && availablePeriod.concernedPath.retour.filter((aTronconSelected) => aTronconSelected.numeroSection === aTroncon.numeroSection).length > 0 : false
                                                                                }
                                                                            />
                                                                        </RadioGroup>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </Grid>
                                            <Grid item sx={{
                                                '&:hover': {
                                                    '> fieldset:first-of-type': {
                                                        borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                                    },
                                                },
                                            }}>
                                                <TextField
                                                    disabled={handleDisabledStep(null, [1, 2, 5])}
                                                    placeholder={'Saisie libre à disposition du client'}
                                                    label='Information complémentaire Client'
                                                    type='text'
                                                    name='clientInfos'
                                                    multiline
                                                    rows={4}
                                                    style={{ width: '100%', margin: '0' }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    value={availablePeriod.additionalInfos.client || ''}
                                                    onChange={(e) => setAvailablePeriod({
                                                        ...availablePeriod,
                                                        additionalInfos: {
                                                            ...availablePeriod.additionalInfos,
                                                            client: e.target.value,
                                                        },
                                                    })}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3} sx={{
                                        '&:hover': {
                                            '> fieldset:first-of-type': {
                                                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                            },
                                        },
                                    }}>
                                        <fieldset style={{ ...css.gridFieldSet }}>
                                            <legend style={css.gridLegend}>Informations convois</legend>
                                            <div>
                                                <FormControl
                                                    style={{ margin: '20px 0', width: '100%' }}
                                                >
                                                    <FormLabel>Contact (*) :</FormLabel>
                                                    <div style={css.gridItem}>
                                                    {availablePeriod.convoyInfos.contact.map((aContact, index) => {
                                                            return (
                                                                <div key={index} style={css.gridItem}>
                                                                    <TextField
                                                                        disabled={handleDisabledStep([1, 2, 3], [PROFIL.CLIENT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        label='Nom :'
                                                                        type='text'
                                                                        name='name'
                                                                        variant={'standard'}
                                                                        style={{ margin: '0', width: '40%' }}
                                                                        value={aContact.name}
                                                                        onChange={(e) => {
                                                                            let contacts = [...availablePeriod.convoyInfos.contact];
                                                                            contacts[index].name = e.target.value;
                                                                            setAvailablePeriod({
                                                                                ...availablePeriod,
                                                                                convoyInfos: {
                                                                                    ...availablePeriod.convoyInfos,
                                                                                    contact: contacts,
                                                                                },
                                                                            });
                                                                        }}
                                                                        autoComplete='off'
                                                                    />
                                                                    <TextField
                                                                        disabled={handleDisabledStep([1, 2, 3], [PROFIL.CLIENT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        label='Tél :'
                                                                        type='text'
                                                                        name='phone'
                                                                        variant={'standard'}
                                                                        style={{ margin: '0', width: '40%' }}
                                                                        value={aContact.phone}
                                                                        onChange={(e) => {
                                                                            let contacts = [...availablePeriod.convoyInfos.contact];
                                                                            contacts[index].phone = e.target.value;
                                                                            setAvailablePeriod({
                                                                                ...availablePeriod,
                                                                                convoyInfos: {
                                                                                    ...availablePeriod.convoyInfos,
                                                                                    contact: contacts,
                                                                                },
                                                                            });
                                                                        }}
                                                                        autoComplete='off'
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <MyButton
                                                        disabled={handleDisabledStep([1, 2, 3], [PROFIL.CLIENT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                        label={''}
                                                        icon={faPlus}
                                                        style={'smallDefaultButton'}
                                                        iconStyle={{ marginRight: '0px' }}
                                                        sx={{ minWidth: '0', width: '10%' }}
                                                        onClick={() => {
                                                            let contacts = [...availablePeriod.convoyInfos.contact];
                                                            contacts.push({ name: '', phone: '' });
                                                            setAvailablePeriod({
                                                                ...availablePeriod,
                                                                convoyInfos: {
                                                                    ...availablePeriod.convoyInfos,
                                                                    contact: contacts,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </FormControl>
                                                <FormControl style={{ margin: '20px 0', width: '100%' }}>
                                                    <FormLabel>Immatriculations (*) :</FormLabel>
                                                    <div style={css.gridItem}>
                                                        {availablePeriod.convoyInfos.immatriculations.map((aImmatriculation, index) => {
                                                            return (
                                                                <div key={index} style={css.gridItem}>
                                                                    <TextField
                                                                        disabled={handleDisabledStep([1, 2, 3], [PROFIL.CLIENT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        label='Immatriculation :'
                                                                        type='text'
                                                                        name='immatriculation'
                                                                        variant={'standard'}
                                                                        style={{ margin: '0', width: '100%' }}
                                                                        value={aImmatriculation.immatriculation}
                                                                        onChange={(e) => {
                                                                            let immatriculations = [...availablePeriod.convoyInfos.immatriculations];
                                                                            immatriculations[index].immatriculation = e.target.value;
                                                                            setAvailablePeriod({
                                                                                ...availablePeriod,
                                                                                convoyInfos: {
                                                                                    ...availablePeriod.convoyInfos,
                                                                                    immatriculations: immatriculations,
                                                                                },
                                                                            });
                                                                        }}
                                                                        autoComplete='off'
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                    <MyButton
                                                        disabled={handleDisabledStep([1, 2, 3], [PROFIL.CLIENT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                        label={''}
                                                        icon={faPlus}
                                                        style={'smallDefaultButton'}
                                                        iconStyle={{ marginRight: '0px' }}
                                                        sx={{ minWidth: '0', width: '10%' }}
                                                        onClick={() => {
                                                            let immatriculations = [...availablePeriod.convoyInfos.immatriculations];
                                                            immatriculations.push({ immatriculation: '' });
                                                            setAvailablePeriod({
                                                                ...availablePeriod,
                                                                convoyInfos: {
                                                                    ...availablePeriod.convoyInfos,
                                                                    immatriculations: immatriculations,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </FormControl>
                                                <FormControl
                                                    disabled={(!(profil.profil === PROFIL.CLIENT || profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && !allCentersAccepted) || !canConfirm || isDeleted}
                                                    style={{ margin: '20px 0' }}>
                                                    <FormLabel>Confirmation du passage (*) :</FormLabel>
                                                    <div style={css.gridItem}>
                                                        <RadioGroup name='confirmed'
                                                                    value={availablePeriod.convoyInfos.confirmed !== null ? availablePeriod.convoyInfos.confirmed : null}
                                                                    style={css.gridRadioGroup}
                                                                    onChange={(e) => setAvailablePeriod({
                                                                        ...availablePeriod,
                                                                        convoyInfos: {
                                                                            ...availablePeriod.convoyInfos,
                                                                            confirmed: e.target.value,
                                                                        },
                                                                    })}
                                                        >
                                                            <FormControlLabel value={true}
                                                                              control={<Radio />}
                                                                              label={'Oui'}
                                                                              labelPlacement={'start'} />
                                                            <FormControlLabel value={false}
                                                                              control={<Radio />}
                                                                              label='Non'
                                                                              labelPlacement={'start'} />
                                                        </RadioGroup>
                                                    </div>
                                                </FormControl>
                                            </div>
                                            <FormControl style={{ margin: '20px 0' }}>
                                                <FormLabel style={{ fontSize: '12px' }}>(*) : Confirmation possible les 15 derniers jours avant le passage et obligatoire maximum 3 jours avant le passage.</FormLabel>
                                            </FormControl>
                                        </fieldset>
                                    </Grid>
                                    <Grid item xs={6} sx={{
                                        '&:hover': {
                                            '> fieldset:first-of-type': {
                                                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                            },
                                        },
                                    }}>
                                        <fieldset style={css.gridFieldSet}>
                                            <legend style={css.gridLegend}>Informations centres</legend>
                                            <div style={{ display: 'flex', textAlign: 'center', marginBottom: '20px' }}>
                                                <div style={{ width: '40%' }}></div>
                                                <div style={{ width: '30%' }}>Statut prévisionnel</div>
                                                <div style={{ width: '15%' }}>Validation du passage</div>
                                                <div style={{ width: '15%' }}>Passage effectué</div>
                                            </div>
                                            {availablePeriod.centersList && availablePeriod.centers && availablePeriod.centers.map((aCenter, index) => {
                                                let center = null;

                                                const dir = availablePeriod.concernedPath.selectedPath;
                                                const troncons = availablePeriod.concernedPath[dir] ?? [];
                                                const isFull = String(availablePeriod.concernedPath.full) === "true";

                                                if (isFull || troncons.length === 0) {
                                                    // Trajet complet ou aller/retour non encore peuplé : afficher tous les centres du dossier
                                                    center = availablePeriod.centersList.find((c) => Number(c.id) === Number(aCenter.id));
                                                } else {
                                                    troncons.map((aTroncon) => {
                                                        if (aTroncon.centres && aTroncon.centres.length !== 0 && aTroncon.centres.find((aCenterList) => Number(aCenterList) === Number(aCenter.id))) {
                                                            center = availablePeriod.centersList.find((c) => Number(c.id) === Number(aCenter.id));
                                                        }
                                                    });
                                                }

                                                return center && (
                                                    <div key={index} style={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap',
                                                        marginBottom: '20px',
                                                    }}>
                                                        <div style={{
                                                            width: '35%',
                                                            position: 'relative',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                        }}>
                                                            <div>
                                                                <div>{center.name}</div>
                                                                <FontAwesomeIcon icon={faExclamationCircle}
                                                                                 style={unavailableCenters.includes(Number(center.id)) ? { color: 'red' } : { display: 'none' }} />
                                                            </div>
                                                        </div>
                                                        <div style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            textAlign: 'center',
                                                            width: '60%',
                                                        }}>
                                                            <MyComboBox
                                                                disabled={handleDisabledStep([3], [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE, PROFIL.INTERVENANT])}
                                                                value={centerStatusList.find((aStatus) => aStatus.value === aCenter.status)}
                                                                options={centerStatusList}
                                                                id={'selectedCenterStatus'}
                                                                renderInput={(params) => <TextField {...params}
                                                                                                    label='Statut' />}
                                                                style={{ width: '50%' }}
                                                                sx={{
                                                                    '& .MuiFormControl-root': {
                                                                        margin: '0',
                                                                    },
                                                                }}
                                                                setter={(e) => {
                                                                    let centers = [...availablePeriod.centers];
                                                                    centers[index].status = e ? e.value : 'AWAITING_VALIDATION';
                                                                    setAvailablePeriod({
                                                                        ...availablePeriod,
                                                                        centers: centers,
                                                                    });
                                                                }}
                                                            />
                                                            <div style={{ width: '25%' }}>
                                                                <RadioGroup
                                                                    name={`confirmed-${index}`}
                                                                    value={aCenter.confirmed}
                                                                    style={css.gridRadioGroup}
                                                                    onChange={(e) => {
                                                                        let centers = [...availablePeriod.centers];
                                                                        centers[index].confirmed = e.target.value;
                                                                        setAvailablePeriod({
                                                                            ...availablePeriod,
                                                                            centers: centers,
                                                                        });
                                                                    }}
                                                                >
                                                                    <FormControlLabel
                                                                        disabled={handleDisabledStep([7], [PROFIL.INTERVENANT], [PLANIFICATION_STATUS.CONFIRMED_CLIENT]) && handleDisabledStep([7], [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        value={true}
                                                                        control={<Radio />}
                                                                        label={'Oui'}
                                                                        labelPlacement={'start'}
                                                                    />
                                                                    <FormControlLabel
                                                                        disabled={handleDisabledStep([7], [PROFIL.INTERVENANT], [PLANIFICATION_STATUS.CONFIRMED_CLIENT]) && handleDisabledStep([7], [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        value={false}
                                                                        control={<Radio />}
                                                                        label={'Non'}
                                                                        labelPlacement={'start'}
                                                                    />
                                                                </RadioGroup>
                                                            </div>
                                                            <div style={{ width: '25%' }}>
                                                                <RadioGroup
                                                                    name={`done-${index}`}
                                                                    value={aCenter.done}
                                                                    style={css.gridRadioGroup}
                                                                    onChange={(e) => {
                                                                        let centers = [...availablePeriod.centers];
                                                                        centers[index].done = e.target.value;
                                                                        setAvailablePeriod({
                                                                            ...availablePeriod,
                                                                            centers: centers,
                                                                        });
                                                                    }}
                                                                >
                                                                    <FormControlLabel
                                                                        disabled={handleDisabledStep([7], [PROFIL.INTERVENANT], [PLANIFICATION_STATUS.AGREEMENT_ISSUED]) && handleDisabledStep([7], [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        value={true}
                                                                        control={<Radio />}
                                                                        label={'Oui'}
                                                                        labelPlacement={'start'}
                                                                    />
                                                                    <FormControlLabel
                                                                        disabled={handleDisabledStep([7], [PROFIL.INTERVENANT], [PLANIFICATION_STATUS.AGREEMENT_ISSUED]) && handleDisabledStep([7], [PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                        value={false}
                                                                        control={<Radio />}
                                                                        label={'Non'}
                                                                        labelPlacement={'start'}
                                                                    />
                                                                </RadioGroup>
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '100%' }}>
                                                            <label
                                                                style={{ fontSize: '12px', marginLeft: '5px' }}>Contact
                                                                / Mesures d'exploitation / Motif de
                                                                refus :
                                                            </label>
                                                            <TextField
                                                                disabled={handleDisabledStep([3], [PROFIL.INTERVENANT, PROFIL.ADMINISTRATEUR, PROFIL.GESTIONNAIRE])}
                                                                label=''
                                                                type='text'
                                                                name='name'
                                                                style={{ margin: '0', width: '100%' }}
                                                                size={'small'}
                                                                value={aCenter.comment || ''}
                                                                multiline={true}
                                                                placeholder={'Saisie libre à disposition des centres'}
                                                                onChange={(e) => {
                                                                    let centers = [...availablePeriod.centers];
                                                                    centers[index].comment = e.target.value;
                                                                    setAvailablePeriod({
                                                                        ...availablePeriod,
                                                                        centers: centers,
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </fieldset>
                                    </Grid>
                                    <Grid item xs={6} sx={{
                                        '&:hover': {
                                            '> fieldset:first-of-type': {
                                                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                            },
                                        },
                                    }}>
                                        <TextField
                                            disabled={handleDisabledStep(null, [1, 2])}
                                            placeholder={'Saisie libre à disposition des gestionnaires'}
                                            label='Information complémentaire Service TE'
                                            type='text'
                                            name='serviceInfos'
                                            multiline
                                            rows={4}
                                            style={{ width: '100%', margin: '0' }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={availablePeriod.additionalInfos.services || ''}
                                            onChange={(e) => setAvailablePeriod({
                                                ...availablePeriod,
                                                additionalInfos: {
                                                    ...availablePeriod.additionalInfos,
                                                    services: e.target.value,
                                                },
                                            })}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sx={{
                                        '&:hover': {
                                            '> fieldset:first-of-type': {
                                                borderColor: 'rgba(0, 0, 0, 0.87) !important',
                                            },
                                        },
                                    }}>
                                        <fieldset
                                            style={{
                                                ...css.gridFieldSet,
                                                maxHeight: '95px',
                                                overflowY: 'unset',
                                                minHeight: '95px',
                                            }}>
                                            <legend style={css.gridLegend}>Statut</legend>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel>Date de la demande :</FormLabel>
                                                <span
                                                    style={{ marginLeft: '30px' }}>{availablePeriod.date_creation ? moment(availablePeriod.date_creation).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <FormLabel>Statut de la demande :</FormLabel>
                                                <MyComboBox
                                                    disabled={(profil.profil !== PROFIL.ADMINISTRATEUR && profil.profil !== PROFIL.GESTIONNAIRE) || isDeleted}
                                                    options={statusList}
                                                    value={statusList.find((aStatus) => aStatus.value === availablePeriod.status)}
                                                    id={'selectedStatus'}
                                                    setter={(e) => setAvailablePeriod({
                                                        ...availablePeriod,
                                                        status: e?.value || '',
                                                    })}
                                                    size='small'
                                                />
                                            </div>
                                        </fieldset>
                                    </Grid>
                                </Grid>
                                <div style={{ display: 'flex', justifyContent: 'right' }}>
                                    {isDisabledSaveBtn &&
                                        <div style={{
                                            width: 'auto',
                                            color: '#F18D2D',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}>
                                            Cette demande de passage excède le nombre de demande autorisé par le dossier
                                        </div>
                                    }
                                    {(unavailableCenters.length > 0 && oneCenterUnvailable && !isDisabledSaveBtn) &&
                                        <>
                                            <div style={{
                                                width: 'auto',
                                                color: '#F18D2D',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}>
                                                Un ou plusieurs centres sont indisponibles ou partiellement indisponibles. Votre demande risque d'être rejetée.
                                            </div>
                                            <MyButton
                                                label={'Détail Indisp.'}
                                                style={'buttonValidation'}
                                                onClick={() => setOpenModalIndisponibility(true)}
                                            />
                                        </>
                                    }

                                    { !isDisabledSaveBtn && !isDeleted &&
                                        <MyButton
                                            disabled={isDisabledSaveBtn}
                                            onClick={() => handleValidAvailablePeriod()}
                                            style={isDisabledSaveBtn ? 'buttonRejectedOrange' : 'buttonValidation'}
                                            label={'Enregistrer'}
                                            icon={isDisabledSaveBtn ? faTimes : faCheck}
                                        />
                                    }
                                </div>
                            </>
                        }

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AvailablePeriodModal;
